export const getCookie = (name: string) =>
  new RegExp(`(?: |^)${name}=(.*?)(?:;|$)`).exec(document.cookie)?.[1];

export const removeCookie = (name: string) =>
  (document.cookie = `${name}=; expires=Sat, 1 Jan 2000 00:00:00 UTC; path=/`);
